// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { familyOfBrandsStyles } from "@tps/App/Widgets/TpsFamilyOfBrands/TpsFamilyOfBrands";
import { color, createFadeOutEffect, fadeOutLeftStyles, fadeOutRightStyles, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

familyOfBrandsStyles.container = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    `,
};

familyOfBrandsStyles.title = {
    variant: "h2",
    color: "common.ui1",
    css: css`
        margin-bottom: 42px;
        text-align: center;
        ${xScreen("lte", "sm")} {
            padding: 0 16px;
        }
    `,
};

familyOfBrandsStyles.link = {
    css: css`
        display: flex;
        min-height: 100px;
        color: white;
        font-size: 16px;
    `,
};

familyOfBrandsStyles.carouselWrapper = {
    css: css`
        position: relative;
        display: flex;
        width: 100%;

        ${({ isScrollable, fadeEffectWidth, fadeEffectColor }: any) => {
            if (isScrollable) {
                return css`
                    > .carousel-main-wrapper::before {
                        ${createFadeOutEffect(fadeEffectWidth, "left", fadeEffectColor, true)}
                    }
                    > .carousel-main-wrapper::after {
                        ${createFadeOutEffect(fadeEffectWidth, "right", fadeEffectColor, true)}
                    }
                `;
            }
        }}
    `,
};

familyOfBrandsStyles.carouselExtendedStyles = {
    container: {
        css: css`
            .swiper-slide {
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .carousel-right-icon,
            .carousel-left-icon {
                &,
                & > svg {
                    width: 18px;
                    height: 15px;
                }
            }
        `,
    },
};
